import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root",
})
export class StatusService {
    constructor(private http: HttpClient) {}

    get(): Observable<SystemStatus> {
        return this.http.get<SystemStatus>(`/status`);
    }
}

export type SystemStatus = {
    registeredToday: number;
    registeredThisWeek: number;
    registeredThisMonth: number;
    registeredLastMonth: number;
    activeBots: number;
    lastSchedulerRun?: LastSchedulerRunStats | null;
    nextSchedulerRuns: NextSchedulerRun[];
};

export type LastSchedulerRunStats = {
    id: string;
    scheduledStartAtUtc: Date;
    startedAtUtc?: Date | null;
    endedAtUtc?: Date | null;
    durationSeconds?: number | null;
    botsProcessed: number;
    totalPurchasedStocks: number;
    totalSoldStocks: number;
    schedules: string[];
};

export type NextSchedulerRun = {
    id: string;
    scheduledStartAtUtc: Date;
    schedules: string[];
};

export const DEFAULT_STATUS: SystemStatus = {
    registeredToday: 0,
    registeredThisWeek: 0,
    registeredThisMonth: 0,
    registeredLastMonth: 0,
    activeBots: 0,
    lastSchedulerRun: null,
    nextSchedulerRuns: [],
};
